import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { Signup } from '@app/_models';
import { PaymentSummaryResponse, PaymentVerifyResponse } from '@app/_models/signups/payment';
import { AlertService, PaymentService, SignupService } from '@app/_services';
import { FadvCreditCardComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subject } from 'rxjs';
import { PartnerComponent } from '../partner.component';
import { FadvAlternateAlertComponent } from '@fa-switch-sharedservices/ng-elements';
import { PaymentExtendedComponent } from '@app/shared/payment-extended/payment-extended.component';

@Component({
  selector: 'app-partner-payment',
  templateUrl: './partner-payment.component.html',
  styleUrls: ['./partner-payment.component.css']
})
export class PartnerPaymentComponent implements OnInit {
  @ViewChild('fadvCreditCard') fadvCreditCard!: FadvCreditCardComponent;
  @ViewChild('errorBilling') errorBilling: FadvAlternateAlertComponent;
  @ViewChild('paymentExtended') paymentExtended: PaymentExtendedComponent;
  faform: UntypedFormGroup;
  packageName: string;
  packagePrice: string;
  packageTax: string;
  packageTotal: string;
  addOnPrice: string;
  addOnTotal: string;
  addOnTax: string;
  billingTotal: string;
  loading = false;
  date = new Date();
  locked: boolean;
  authAgreement: string;
  innerWidth: number = window.innerWidth;
  errorMessage: string;
  signup: Signup;
  totalTax: number = 0;
  private viewInitWaiter = new Subject();

  constructor(private signupService: SignupService,
    private paymentService: PaymentService,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private router: Router,
    private partnerComponent: PartnerComponent,
    private appComponent: AppComponent
  ) { }
  ngOnInit(): void {
    this.handleGetSignup();
    this.handlePricing();
    if(this.signup.ccfirstname != undefined)
    {
      this.handlePatchedValues()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngAfterViewInit(): void {
    this.authAgreement = "By clicking \"Save Payment\" I hereby, authorize and request First Advantage to charge my credit card for balances due for services rendered which may include later incurred additional court access fees related to the services. This authorization will remain in effect for a period of 90 days."
    // var signup = this.signupService.getSignup();
    // //this always makes me laugh and should be left in forever - Cory B 7/26/22
    // //SORTA OUT WHEN TO CALL SIGNUP, POPULATE SIGNUP WITH VALIDATION
    // //SORT OUT WHEN TO CALL THE CODE BLOCK BELOW
    // //WORKING BUT UGLY, JUST LIKE ME
    // //Nolan D 3/25/22
    // //Working and beautiful, just like you, 08/10/22 - TOBC
    this.viewInitWaiter.complete();
    this.partnerComponent.setStep(this.router.url);
  }

  handlePricing(){
    this.paymentService.summary(this.signup).subscribe(data => {
      this.handleSummary(data);
    });
  }

  handleGetSignup(){
    this.signup = this.signupService.getSignup();
    if (this.appComponent.partner == false) {
      this.handleRefresh();
    }
  }
  handleRefresh() {
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo;
  }

  onSubmit() {
    this.loading = true;
    this.alertService.clear();

    this.faform;

    // stop here if form is invalid
    if (this.fadvCreditCard.invalid) {
      this.errorMessage = "Please make sure your credit card information is correct";
      this.errorBilling.show();
      this.loading = false;
      return;
    }
    
    this.paymentExtended.checkValid();
    
    if (this.paymentExtended.invalid) {
      this.errorMessage = "Please make sure your credit card address information is correct";
      this.errorBilling.show();
      this.loading = false;
      return;
    }

    this.handlePayment()
  }

  handlePayment(){
    var currentCC = this.fadvCreditCard.cardNumber;
        // handle cc no change, still contains stars, profile set
    if (/^\*{1,}\d{4}/.test(currentCC) && currentCC == this.signup.ccnumber && this.signup.ccprofileid.length > 0) {
      this.proceed();
    } else {
      this.faform = this.formBuilder.group({
        ccfirstname: [this.fadvCreditCard.firstName, Validators.required],
        cclastname: [this.fadvCreditCard.lastName, Validators.required],
        ccnumber: [this.fadvCreditCard.cardNumber, [Validators.required, Validators.minLength(12)]],
        ccmonth: [this.fadvCreditCard.month, [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        ccyear: [this.fadvCreditCard.year.slice(2), [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        ccsecuritycode: [this.fadvCreditCard.csc, [Validators.required, Validators.minLength(3)]],
        ccaddress: [this.paymentExtended.paymentExtra.controls.ccaddress.value, [Validators.required]],
        cccity: [this.paymentExtended.paymentExtra.controls.cccity.value, [Validators.required]],
        ccregion: [this.paymentExtended.paymentExtra.controls.ccregion.value, [Validators.required]],
        cccountry: [this.paymentExtended.paymentExtra.controls.cccountry.value, [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
        ccpostal: [this.paymentExtended.paymentExtra.controls.ccpostal.value,  [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]]
      });
      this.paymentService.verify(this.faform.value).subscribe(data => {
        this.handleResponse(data);
      });
    }
  }

  handlePatchedValues(){
    this.fadvCreditCard.firstName = this.signup.ccfirstname;
    this.fadvCreditCard.lastName = this.signup.cclastname;
    this.fadvCreditCard.cardNumber = this.signup.ccnumber;
    this.fadvCreditCard.month = this.signup.ccmonth;
    this.fadvCreditCard.year = this.signup.ccyear;
    this.fadvCreditCard.csc = this.signup.ccsecuritycode;
    this.paymentExtended.ccaddress = this.signup.ccaddress;
    this.paymentExtended.cccity = this.signup.cccity;
    this.paymentExtended.ccregion = this.signup.ccregion;
    this.paymentExtended.ccpostal = this.signup.ccpostal;
  }
  handleSaveValidCardToSignup(){
    this.signup.ccfirstname = this.fadvCreditCard.firstName;
    this.signup.cclastname = this.fadvCreditCard.lastName;
    this.signup.ccnumber = this.fadvCreditCard.cardNumber;
    this.signup.ccmonth = this.fadvCreditCard.month;
    this.signup.ccyear = this.fadvCreditCard.year;
    this.signup.ccsecuritycode = this.fadvCreditCard.csc;
    this.signup.ccaddress = this.paymentExtended.ccaddress;
    this.signup.cccity = this.paymentExtended.cccity;
    this.signup.ccregion = this.paymentExtended.cccountry;
    this.signup.ccpostal = this.paymentExtended.ccpostal;
    this.signup.cccountry = this.paymentExtended.cccountry;
  }
  proceed() {
    this.partnerComponent.paymentStep.visited = true;
    this.router.navigate(['/partner/account']);
  }

  getDate() {
    return this.date;
  }

  disableSubmit() {
    return !this.fadvCreditCard.valid || this.locked;
  }

  handleSummary(summaryResponse: PaymentSummaryResponse) {
    if (summaryResponse.error == true) {
      this.alertService.error(summaryResponse.message);
      this.loading = false;
      return;
    }
    this.locked = false;
    if (summaryResponse.packageEntryResult) {
      this.packageName = summaryResponse.packageEntryResult.packageName;
      this.packagePrice = summaryResponse.packageEntryResult.price;
      this.packageTax = summaryResponse.packageEntryResult.tax;
      this.packageTotal = summaryResponse.packageEntryResult.total;
    }
    if (summaryResponse.addOnEntryResult) {
      this.addOnPrice = summaryResponse.addOnEntryResult.price;
      this.addOnTax = summaryResponse.addOnEntryResult.tax;
      this.addOnTotal = summaryResponse.addOnEntryResult.total;
    }
    this.totalTax = summaryResponse.addOnEntryResult.taxNum + summaryResponse.packageEntryResult.taxNum;
    this.billingTotal = summaryResponse.billingTotal;
  }

  handleResponse(verifyResponse: PaymentVerifyResponse) {
    if (verifyResponse.error == true) {
      this.errorMessage = verifyResponse.message;
      this.errorBilling.show();
      this.loading = false;
      return;
    }

    this.signupService.savePayment(this.faform.value, verifyResponse.accountId, verifyResponse.profileId, this.authAgreement);

    this.proceed();
  }

  onCancel() {
    this.router.navigate(['/partner/candidate'])
  }
}


